import WirePayeesPage from "components/pages/WirePayeesPage";

/**
 * @name CaptureWirePayeesDefault
 * @returns {React.Component}
 * @description 
 */
export default function CaptureWirePayeesDefault(props) {
    return <WirePayeesPage/>;
}